import angular from "angular";

import { AccountingData, Dates, Reports } from "@salaxy/core";
import { UiHelpers } from "../../services";

/**
 * Provides functionality for building ad hoc accounting holiday pay debt reports.
 */
export class AccountingHolidayPayDebtReportQueryController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [
    "Reports",
    "UiHelpers",
  ];

  /**
   * Report view table only (partial) or pdf preview (full)
   * Defaults to 'partial'
   */
  public view: "partial" | "full";

  /** Ref date to which the debt is calculated. */
  public refDate: string = Dates.getToday();

  /** Accounting data */
  public data: AccountingData;

  /**Selected report language */
  public lang: string;

  /** Data reader for the control. */
  public dataReader = {
  /**
   * Function to read data into given array
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
   read: (target: string, ruleSet: string, arr: AccountingData[], message: string): Promise<void> => {
      if (this.data) {
        arr.push(this.data);
      }
      return Promise.resolve();
    },
    /** Optional label for data export */
    exportLabel: null,
    /** Indicates if the export is not possible */
    disabled: () => !this.data,
    /* Indicates if row is expandable */
    showExpand: true,
    /* Indicates if rows exists*/
    hasRows: () => !this.data?.ledgerAccounts
  };

  constructor(
    private reportsApi: Reports,
    private uiHelpers: UiHelpers,
  ) {
    // Dependency injection
  }

  /**
   * Initialize controller values.
   */
  public $onInit() {
    this.view = this.view || "partial";
  }

  /** Queries the report data. */
  public queryData(target = "default") {
    const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    this.reportsApi.getAccountingDataForHolidayPayDebt(this.refDate, target)
      .then((result) => {
        this.data = result;
        loading.dismiss();
    });
  }
}
